<script>
import moment from "moment";
import axios from "axios";
import TitlePage from "../layout/TitlePage.vue";
import Card from "../ui/Card.vue";
import { getDocument } from "pdfjs-dist";
import Serve from "../ui/prueba/serve.vue";
import ModalFormEditStatusVistoBueno from "../modals/ModalFormEditStatusVistoBueno.vue";
import ModalFormEditStatusUsoDisposicion from "../modals/ModalFormEditStatusUsoDisposicion.vue";

const TIPO_DOCUMENTO_ID = Object.freeze({ 
  DIN_GENERICO: 4, 
  DIN_PAGADO: 33, 
  DIN_PENDIENTE: 34,
});

export default {
  components: {
    TitlePage,
    Card,
    Serve,
    ModalFormEditStatusVistoBueno,
    ModalFormEditStatusUsoDisposicion,
  },
  computed: {
    esDocumentoDIN() {
      const idsDIN = Object.values(TIPO_DOCUMENTO_ID).includes(this.documento.tipo_documentos_id);
      return this.documento && idsDIN;
    },
  },
  emits: ["refetch"],
  data() {
    return {
      id: "",
      idDocumento: null,
      idDescargar: null,
      idArchivo: null,

      visorImagen: new Image(),

      numeroPaginas: 0,
      paginaActual: 1,

      visorWidth: 1000,
      visorHeight: 800,

      tipoDeArchivo: "",

      documento: [],
      despacho: {},
      nombre_documento: "",

      showEditStatus: false,
    };
  },
  created() {
    window.addEventListener("resize", this.redimensionarVentana);
  },
  destroyed() {
    window.removeEventListener("resize", this.redimensionarVentana);
  },
  mounted() {
    this.id = this.$route.params.despachoId;
    this.idDocumento = this.$route.params.documentoId;

    const despacho_id = this.$route.params.despachoId;
    console.log(despacho_id);
    this.getDespacho(despacho_id);
    this.getDocumento();

    //this.mostrarDocumento()
  },
  methods: {
    abrirDocumento(id, nombre) {
      this.idArchivo = id;
      this.idDescargar = id;
      this.nombre_documento = nombre.split("/")[1];
      this.mostrarDocumento();
    },
    mostrarDocumento() {
      axios
        .get(`/api/archivo/${this.idArchivo}/descargar`)
        .then((res) => {
          if (res.headers["content-type"] == "application/pdf") {
            this.tipoDeArchivo = "pdf";
            this.cargarPDF(this.paginaActual);
          } else if (
            res.headers["content-type"] == "image/png" ||
            res.headers["content-type"] == "image/jpeg"
          ) {
            this.tipoDeArchivo = "png";
            this.cargarImagen();
          } else {
            this.tipoDeArchivo = "otro";
          }
        })
        .catch((err) => console.log(err));

      if (screen.width <= 320) {
        this.visorWidth = 280;
        this.visorHeight = 640;
      } else if (screen.width < 600) {
        this.visorWidth = 340;
        this.visorHeight = 640;
      } else if (screen.width <= 768) {
        this.visorWidth = 550;
        this.visorHeight = 690;
      } else if (screen.width < 1024) {
        this.visorWidth = 700;
        this.visorHeight = 690;
      } else {
        this.visorWidth = 1000;
        this.visorHeight = 890;
      }

      var init = false;
      this.visorImagen.onload = () => {
        var canvas = document.getElementById("visor-canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = this.visorWidth;
        canvas.height = this.visorHeight;
        this.trackTransforms(ctx);

        var firstDraw = true;

        let redraw = () => {
          // Clear the entire canvas
          var p1 = ctx.transformedPoint(0, 0);
          var p2 = ctx.transformedPoint(canvas.width, canvas.height);
          ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.restore();
          if (this.visorImagen.src !== "") {
            if (firstDraw == true) {
              var ss = canvas.height / this.visorImagen.height;
              ctx.translate(
                (canvas.width - this.visorImagen.width * ss) / 2,
                0
              );
              ctx.scale(ss, ss);
              firstDraw = false;
            }
            ctx.drawImage(this.visorImagen, 0, 0);
          }
        };
        redraw();

        if (init == false) {
          var lastX = canvas.width / 2,
            lastY = canvas.height / 2;
          var dragStart, dragged;
          canvas.addEventListener(
            "mousedown",
            function (evt) {
              document.body.style.mozUserSelect =
                document.body.style.webkitUserSelect =
                document.body.style.userSelect =
                  "none";
              lastX = evt.offsetX || evt.pageX - canvas.offsetLeft;
              lastY = evt.offsetY || evt.pageY - canvas.offsetTop;
              dragStart = ctx.transformedPoint(lastX, lastY);
              dragged = false;
            },
            false
          );

          canvas.addEventListener(
            "mousemove",
            function (evt) {
              lastX = evt.offsetX || evt.pageX - canvas.offsetLeft;
              lastY = evt.offsetY || evt.pageY - canvas.offsetTop;
              dragged = true;
              if (dragStart) {
                var pt = ctx.transformedPoint(lastX, lastY);
                ctx.translate(pt.x - dragStart.x, pt.y - dragStart.y);
                redraw();
              }
            },
            false
          );

          canvas.addEventListener(
            "mouseup",
            function (evt) {
              dragStart = null;
              if (!dragged) zoom(evt.shiftKey ? -1 : 1);
            },
            false
          );

          canvas.addEventListener(
            "mouseout",
            function (evt) {
              dragStart = null;
            },
            false
          );

          var scaleFactor = 1.05;

          var zoom = function (clicks) {
            var pt = ctx.transformedPoint(lastX, lastY);
            ctx.translate(pt.x, pt.y);
            var factor = Math.pow(scaleFactor, clicks);
            ctx.scale(factor, factor);
            ctx.translate(-pt.x, -pt.y);
            redraw();
          };

          var handleScroll = function (evt) {
            var delta = evt.wheelDelta
              ? evt.wheelDelta / 40
              : evt.detail
              ? -evt.detail
              : 0;
            if (delta) zoom(delta);
            return evt.preventDefault() && false;
          };

          canvas.addEventListener("DOMMouseScroll", handleScroll, false);
          canvas.addEventListener("mousewheel", handleScroll, false);
          init = true;
        }
      };
    },
    async getDespacho(despacho_id) {
      const { data } = await axios.get(`api/admin/despachos/${despacho_id}`);
      if (data?.data) this.despacho = { ...data.data };
    },
    async getDocumento() {
      await axios
        .get(`/api/admin/documentos/${this.idDocumento}`)
        .then((res) => {
          this.documento = res?.data?.data;
        });
    },
    async validar(estado) {
      await axios
        .post(`api/admin/documentos/${this.idDocumento}/validar`, {
          estado: estado,
        })
        .then((res) => {
          this.getDocumento();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async downloadDocumento() {
      window.open(
        process.env.VUE_APP_API_URL +
          `/api/admin/archivo/${this.idDescargar}/descargar/despacho`
      );
    },
    volverDespacho() {
      this.$router.push({
        name: "PerfilDespacho",
        params: { despachoId: this.id },
      });
    },
    redimensionarVentana(e) {
      //console.log(e.windows)
    },
    atrasPagina() {
      this.paginaActual = this.paginaActual - 1;
      this.cargarPDF(this.paginaActual);
    },
    siguientePagina() {
      this.paginaActual = this.paginaActual + 1;
      this.cargarPDF(this.paginaActual);
    },
    cargarPDF(pagina) {
      // Asynchronous download of PDF
      var loadingTask = getDocument(
        process.env.VUE_APP_API_URL + `/api/archivo/${this.idArchivo}/descargar`
      );
      loadingTask.promise.then(
        (pdf) => {
          console.log(pdf.numPages);
          this.numeroPaginas = pdf.numPages;
          pdf.getPage(pagina).then((page) => {
            // Prepare canvas using PDF page dimensions
            var canvas_pdf = document.getElementById("visor-pdf-gen");
            var context = canvas_pdf.getContext("2d");
            var viewport = page.getViewport({ scale: 6 });
            canvas_pdf.width = viewport.width;
            canvas_pdf.height = viewport.height;

            // Render PDF page into canvas context
            var renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(() => {
              this.visorImagen.src = canvas_pdf.toDataURL("image/png");
            });
          });
        },
        function (reason) {
          // PDF loading error
          console.error(reason);
        }
      );
    },
    cargarImagen() {
      this.visorImagen.src =
        process.env.VUE_APP_API_URL +
        `/api/archivo/${this.idArchivo}/descargar`;
    },
    trackTransforms(ctx) {
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var xform = svg.createSVGMatrix();
      ctx.getTransform = function () {
        return xform;
      };

      var savedTransforms = [];
      var save = ctx.save;
      ctx.save = function () {
        savedTransforms.push(xform.translate(0, 0));
        return save.call(ctx);
      };

      var restore = ctx.restore;
      ctx.restore = function () {
        xform = savedTransforms.pop();
        return restore.call(ctx);
      };

      var scale = ctx.scale;
      ctx.scale = function (sx, sy) {
        xform = xform.scaleNonUniform(sx, sy);
        return scale.call(ctx, sx, sy);
      };

      var rotate = ctx.rotate;
      ctx.rotate = function (radians) {
        xform = xform.rotate((radians * 180) / Math.PI);
        return rotate.call(ctx, radians);
      };

      var translate = ctx.translate;
      ctx.translate = function (dx, dy) {
        xform = xform.translate(dx, dy);
        return translate.call(ctx, dx, dy);
      };

      var transform = ctx.transform;
      ctx.transform = function (a, b, c, d, e, f) {
        var m2 = svg.createSVGMatrix();
        m2.a = a;
        m2.b = b;
        m2.c = c;
        m2.d = d;
        m2.e = e;
        m2.f = f;
        xform = xform.multiply(m2);
        return transform.call(ctx, a, b, c, d, e, f);
      };

      var setTransform = ctx.setTransform;
      ctx.setTransform = function (a, b, c, d, e, f) {
        xform.a = a;
        xform.b = b;
        xform.c = c;
        xform.d = d;
        xform.e = e;
        xform.f = f;
        return setTransform.call(ctx, a, b, c, d, e, f);
      };

      var pt = svg.createSVGPoint();
      ctx.transformedPoint = function (x, y) {
        pt.x = x;
        pt.y = y;
        return pt.matrixTransform(xform.inverse());
      };
    },

    visorLimpiar() {
      var canvas = document.getElementById("visor-canvas");
      canvas.width = 800;
      canvas.height = 400;
      var ctx = canvas.getContext("2d");
      var p1 = ctx.transformedPoint(0, 0);
      var p2 = ctx.transformedPoint(canvas.width, canvas.height);
      ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
      this.visorImagen.src = "";
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-12 w-full !text-left">
    <title-page title="Despachos" />

    <card
      title="Documento despacho"
      :segundoaccionBoton="volverDespacho"
      :segundoboton="true"
      segundotext="Volver"
      :accionBoton="downloadDocumento"
      :boton="idDescargar != null"
      text="Descargar"
    >
      <div
        class="flex flex-row items-center gap-4 sm:justify-end"
        v-permisos="'revisor.view'"
      >
        <!-- si el documento no es VB-o Uso y dispsocio -->
        <div
          v-if="!(documento?.tipo?.id == 2 || documento?.tipo?.id == 35)"
          class="flex flex-row items-center gap-2"
        >
          <button
            @click="validar('Aceptado')"
            class="btn-secundario w-full sm:w-fit"
          >
            Aceptado
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/Editar.svg"
              title="My Image"
            />
          </button>
          <button
            @click="validar('Rechazado')"
            class="btn-principal w-full sm:w-fit"
          >
            Rechazado
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/basura.svg"
              title="My Image"
            />
          </button>
        </div>

        <!-- Si el documento es visto bueno -->
        <div v-if="documento?.tipo?.id == 2">
          <button
            class="btn-principal"
            @click="() => (showEditStatus = !showEditStatus)"
          >
            Cambiar estado
          </button>
          <ModalFormEditStatusVistoBueno
            :visible="showEditStatus"
            :documento="documento"
            @close-modal="() => (showEditStatus = false)"
            @refetch="() => getDocumento()"
          />
        </div>
        <!-- Si el documento es Uso disposicion -->
        <div v-if="documento?.tipo?.id == 35">
          <button
            class="btn-principal"
            @click="() => (showEditStatus = !showEditStatus)"
          >
            Cambiar estado
          </button>
          <ModalFormEditStatusUsoDisposicion
            :visible="showEditStatus"
            :documento="documento"
            @close-modal="() => (showEditStatus = false)"
            @refetch="() => getDocumento()"
          />
        </div>
      </div>

      <div v-if="documento.tipo" class="flex flex-col gap-4 pb-4">
        <div class="grid grid-cols-2 border-b border-primary/20">
          <div class="text-left">Cliente</div>
          <div class="font-bold text-right">
            {{ despacho.cliente?.nombre ?? "-" }}
          </div>
        </div>

        <div class="grid grid-cols-2 border-b border-primary/20">
          <div class="text-left">N° Despacho</div>
          <div class="font-bold text-right">{{ despacho?.codigo ?? "-" }}</div>
        </div>
        <!--DOCUMENTOS GENERALES -->
        <div class="grid grid-cols-2 border-b border-primary/20">
          <div class="text-left">Tipo de documento</div>

          <div class="font-bold text-right">
            {{ documento.tipo.nombre ?? "-" }}
          </div>
        </div>

        <div class="grid grid-cols-2 border-b border-primary/20">
          <div class="text-left">Fecho Recepción</div>

          <div class="font-bold text-right">
            {{
              documento.fecha_recepcion
                ? moment(documento.fecha_recepcion).format("DD-MM-YYYY")
                : "-"
            }}
          </div>
        </div>

        <div
          v-if="documento.tipo?.id != 2"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Estado Validación</div>

          <div class="font-bold text-right">
            {{ documento.estado?.toUpperCase() ?? "-" }}
          </div>
        </div>

        <!-- Documento de transporte-->
        <div
          v-if="documento.tipo_documentos_id == 1"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Tipo Transporte</div>

          <div class="font-bold text-right">
            {{ documento.base?.tipo_transporte ?? "-" }}
          </div>
        </div>

        <div
          v-if="documento.tipo_documentos_id == 1"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Número Documento</div>

          <div class="font-bold text-right">
            {{ documento.base?.numero_documento ?? "-" }}
          </div>
        </div>

        <!-- Documento de Vistos Buenos-->
        <!------->
        <div
          v-if="documento.tipo?.id == 2"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Estado Validación (VB)</div>

          <div class="font-bold text-right">
            {{ documento?.base?.estado?.toUpperCase() ?? "-" }}
          </div>
        </div>

        <div
          v-if="documento.tipo_documentos_id == 2"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Tipo de Visto Bueno (CDA)</div>

          <div class="font-bold text-right">
            {{ documento?.base?.tipo_vistos_buenos ?? "-" }}
          </div>
        </div>

        <div
          v-if="
            documento.tipo_documentos_id == 2 ||
            documento.tipo_documentos_id == 35
          "
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">N° de solicitud</div>

          <div class="font-bold text-right">
            {{ documento?.numero_solicitud ?? "-" }}
          </div>
        </div>

        <div
          v-if="
            documento.tipo_documentos_id == 2
          "
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Requiere UyD</div>

          <div class="font-bold text-right">
            {{ documento?.base.requiere_uyd ? "Si" : "No" }}
          </div>
        </div>

        <div
          v-if="documento.tipo_documentos_id == 35"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Estado (Uso y disposición)</div>

          <div class="font-bold text-right">
            {{ documento?.base?.estado?.toUpperCase() ?? "-" }}
          </div>
        </div>

        <div
          v-if="
            (documento.tipo_documentos_id == 2 ||
              documento.tipo_documentos_id == 35) &&
            documento?.base?.estado == 'Aprobado'
          "
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Fecha de aprobación</div>

          <div class="font-bold text-right">
            {{
              documento?.base.fecha_aprobacion
                ? moment(documento?.base.fecha_aprobacion).format(
                    "DD-MM-YYYY HH:mm"
                  )
                : "-"
            }}
          </div>
        </div>

        <!------->

        <div
          v-if="documento.tipo_documentos_id == 3"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Status Bl</div>

          <div class="font-bold text-right">
            {{ documento?.base?.status ?? "-" }}
          </div>
        </div>

        <!-- Documento de Tipo DIN-->
        <div
          v-if="esDocumentoDIN"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Fecha Aceptación</div>

          <div class="font-bold text-right">
            {{
              documento?.base?.fecha_aceptacion
                ? moment(documento.base.fecha_aceptacion).format("DD-MM-YYYY")
                : "-"
            }}
          </div>
        </div>

        <!-- Documento de Tipo GUIA DESPACHO-->
        <div
          v-if="documento.tipo_documentos_id == 10"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Número Guía Despacho</div>

          <div class="font-bold text-right">
            {{ documento?.base?.numero_guia_despacho ?? "-" }}
          </div>
        </div>
        <!-- Documento de Tipo GUIA DESPACHO-->
        <div
          v-if="documento?.tipo_documentos_id == 17"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Fecha Presentación</div>

          <div class="font-bold text-right">
            {{
              documento?.base?.fecha_presentacion
                ? moment(documento.base.fecha_presentacion).format("DD-MM-YYYY")
                : "-"
            }}
          </div>
        </div>

        <div
          v-if="documento.tipo_documentos_id == 17"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Hora Presentación</div>

          <div class="font-bold text-right">
            {{ documento?.base?.hora_presentacion ?? "-" }}
          </div>
        </div>

        <div
          v-if="documento.tipo_documentos_id == 17"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Número Dus</div>

          <div class="font-bold text-right">
            {{ documento?.base?.numero_dus ?? "-" }}
          </div>
        </div>

        <div
          v-if="documento.tipo_documentos_id == 17"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Fecha Vencimiento</div>

          <div class="font-bold text-right">
            {{
              documento?.base?.fecha_vencimiento
                ? moment(documento.base.fecha_vencimiento).format("DD-MM-YYYY")
                : "-"
            }}
          </div>
        </div>

        <!-- Documento de Tipo DUS LEGALIZADO-->
        <div
          v-if="documento?.tipo_documentos_id == 17"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Estado Dus</div>

          <div class="font-bold text-right">
            {{ documento?.base?.estado ?? "-" }}
          </div>
        </div>
        <div
          v-if="documento.tipo_documentos_id == 17"
          class="grid grid-cols-2 border-b border-primary/20"
        >
          <div class="text-left">Fecha Dus Legalizado</div>

          <div class="font-bold text-right">
            {{
              documento?.base?.fecha_dus_legalizado
                ? moment(documento.base.fecha_dus_legalizado).format(
                    "DD-MM-YYYY"
                  )
                : "-"
            }}
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <h1 class="!text-xl !font-bold">Archivos</h1>

        <div class="flex flex-row flex-wrap gap-4">
          <div
            class=""
            v-for="archivo in documento.archivos"
            v-bind:key="archivo.id"
          >
            <button
              class="w-12 h-12 hover:scale-110 transition-all"
              v-b-tooltip.hover
              :title="archivo.ruta"
              @click="abrirDocumento(archivo.id, archivo.ruta)"
            >
              <inline-svg
                class="size-12"
                v-if="archivo.ruta.split('.').at(-1) == 'pdf'"
                src="./../../../../assets/images/archivo-pdf.svg"
              />
              <inline-svg
                class="size-12"
                v-if="
                  archivo.ruta.split('.').at(-1) == 'png' ||
                  archivo.ruta.split('.').at(-1) == 'jpg' ||
                  archivo.ruta.split('.').at(-1) == 'jpeg'
                "
                src="../../assets/images/archivo-png.svg"
              />
              <inline-svg
                class="size-12"
                v-if="
                  archivo.ruta.split('.').at(-1) == 'xlsx' ||
                  archivo.ruta.split('.').at(-1) == 'xls'
                "
                src="./../../../../assets/images/732220.svg"
              />
            </button>
          </div>
        </div>
      </div>

      <div id="visualizacion-documentos-adjuntos-1" class="flex flex-col gap-4">
        <div v-if="tipoDeArchivo === ''" style="text-align: center">
          <h3 class="!text-xl !font-bold text-left">
            {{ nombre_documento }}
          </h3>
        </div>
        <div v-else>
          <h3 class="!text-xl !font-bold text-left">{{ nombre_documento }}</h3>
          <div
            class="flex flex-col gap-4 w-full"
            v-if="tipoDeArchivo === 'png' || tipoDeArchivo === 'pdf'"
          >
            <canvas id="visor-pdf-gen"></canvas>
            <div class="visor-cuerpo">
              <canvas
                id="visor-canvas"
                :width="visorWidth"
                :height="visorHeight"
              ></canvas>
            </div>
            <div
              class="flex flex-row w-36 justify-center mx-auto gap-4 text-center"
              v-if="tipoDeArchivo == 'pdf'"
            >
              <button
                class="btn-principal !w-4"
                @click="atrasPagina()"
                :disabled="paginaActual <= 1"
              >
                <fas :icon="['fas', 'chevron-left']" />
              </button>
              <button class="btn-nomx text-white bg-secondary/80">
                {{ paginaActual }}
              </button>
              <button
                @click="siguientePagina()"
                class="btn-principal !w-4"
                :disabled="paginaActual == numeroPaginas"
              >
                <fas :icon="['fas', 'chevron-right']" />
              </button>
            </div>
          </div>
          <div v-else>
            <h3>No se puede visualizar el archivo.</h3>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<style>
.gutter-sm > [class*="col-"] {
  padding: 0px 5px;
}
.visor {
  height: calc(100% - 70px);
}
.visor-cuerpo {
  margin: auto;
  width: fit-content;
  height: calc(100% - 64px);
  text-align: center;
  display: block;
  position: relative;
  background: #eeeeee;
  cursor: all-scroll;
}
.visor-cerrar {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: #ececef;
  color: #372268;
  font-size: 15pt;
  cursor: pointer;
}
#visor-canvas {
  display: inline-block;
  max-width: 800px;
}
#visor-pdf-gen {
  display: none;
}
.visor-opciones {
  height: 64px;
  text-align: center;
  padding-top: 15px;
}
.visor-opciones span {
  font-size: 18pt;
}
.visor-opciones .opcion-adjuntar {
  color: #372368;
}
.visor-opciones .opcion-eliminar {
  color: red;
}
.visor-opciones .mensaje {
  font-size: 11pt;
}
button.btn-link {
  word-wrap: break-word;
  white-space: normal;
  color: white !important;
  text-decoration: none !important;
}
button.btn-link:hover {
  text-decoration: none !important;
}
button.btn-rounded-2 {
  border-radius: 20px;
}
.archivo-protocolo {
  color: #372268;
}
.archivo-protocolo.submitted {
  color: #31c5d6;
}
.archivo-protocolo.active {
  color: #068800 !important;
}
.ver-doc-ref {
  color: #372268;
}
.ver-doc-ref.active {
  color: #098000;
}
</style>
